import React,{Component} from 'react';
import {TextField,Select,MenuItem,Table,IconButton,Icon,
    TableRow,TableHead,TableBody,TableCell,
    Button} from '@material-ui/core';

    
import ICONODESCARGA from '@material-ui/icons/ArrowDropDownCircle';
import DBHandler from '../DBHandler';

import IIBB from '../pdfs/RetencionLiquidacion';
import LIQ from '../pdfs/AportesMedicosLiquidacion';

export default class ListarLiquidaciones extends Component{
    constructor(props){
        super(props);
        this.state = {
            liquidaciones:props.liquidaciones,
            seleccionado:null,
        }
    }

    componentWillReceiveProps(props){
        this.setState({
            liquidaciones:props.liquidaciones,
            seleccionado:null
        })
    }

    seleccionar(elegido){
        this.setState({
            seleccionado:elegido
        })
    }


    render(){
        return(<div style={{margin:'10px',marginTop:'50px'}}>
            {this.state.seleccionado !== null ? 
                <div>
                <Button onClick={()=>this.setState({seleccionado:null})}
                color='secondary' fullWidth variant='contained'
                >volver</Button>
                {this.state.seleccionado}
                </div>:
            <Listado liquidaciones={this.state.liquidaciones}
                seleccionar={this.seleccionar.bind(this)}
            ></Listado>}
        </div>)
    }

    
}



class Listado extends Component{
    constructor(props){
        super(props);
        this.state={
            liquidaciones:props.liquidaciones
        }
        this.seleccionar = props.seleccionar;

    }

    componentWillReceiveProps(props){
        this.setState({
            liquidaciones:props.liquidaciones
        })
    }

    render(){
        return <div>
            <Table size='small'>
                <TableHead>
                    <TableRow>
                        <TableCell>
                            Liquidacion
                        </TableCell>
                        <TableCell>
                            Ejercicio
                        </TableCell>
                        <TableCell>
                            Mes
                        </TableCell>
                        <TableCell>
                            Descripcion
                        </TableCell>
                        <TableCell>
                            Deduccion
                        </TableCell>
                        <TableCell>
                            Descarga
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.liquidaciones.map((elem,ind)=><LineaTabla liq={elem} key={ind}
                        seleccionar={this.seleccionar}
                    />)}
                </TableBody>
            </Table>
        </div>
    }
}



class LineaTabla extends Component{
    constructor(props){
        super(props);
        this.state={
            liq:props.liq,
        }
        this.seleccionar = props.seleccionar;
    }

    componentWillReceiveProps(props){
        this.setState({
            liq:props.liq
        })
    }

    render(){
        return <TableRow>
            <TableCell>
                {this.state.liq.nro_recibo}
            </TableCell>
            <TableCell>
                {this.state.liq.anio}
            </TableCell>
            <TableCell>
                {this.state.liq.mes}
            </TableCell>
            <TableCell>
                {this.state.liq.descripcion}
            </TableCell>
            <TableCell>
                {this.state.liq.retencion}
            </TableCell>
            <TableCell>
                <IconButton  style={{display:'inline-block'}} size='small' 
                    onClick={
                        ()=>{
                            let act = this.state.liq
                            this.seleccionar(act.concepto === '7536' ? 
                                    <LIQ
                                        anio={act.anio}
                                        mes={act.mes}
                                        nro_recibo={act.nro_recibo}
                                        concepto={act.concepto}
                                    /> 
                                    :
                                    <IIBB 
                                        anio={act.anio}
                                        mes={act.mes}
                                        nro_recibo={act.nro_recibo}
                                        concepto={act.concepto}
                                />)}
                    } >
                    <Icon> <ICONODESCARGA/> </Icon>
                </IconButton>
            </TableCell>
            
        </TableRow>
    }
}